<template>
  <div class="h-full flex flex-col min-h-0 bg-[#fafbfc] relative overflow-hidden min-w-0">
    <header class="px-8 py-6 sticky top-0 z-20 bg-[#fafbfc]/90 backdrop-blur-md border-b border-[#1c4848]/5 shrink-0">
      <div class="max-w-[1600px] mx-auto">
        <div class="flex items-center gap-2 text-[#1c4848]/40 mb-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="shrink-0"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/></svg>
          <span class="text-[10px] font-bold uppercase tracking-wider">Postavke</span>
        </div>
        <h1 class="text-2xl font-serif font-medium text-[#1c4848] tracking-tight">Postavke aplikacije</h1>
      </div>
    </header>

    <div class="flex-1 min-h-0 overflow-y-auto custom-scrollbar pt-8 pr-8 pb-32 pl-8">
      <div class="max-w-[1600px] mx-auto space-y-8">
        <AccessCard />
        <AiModelsCard />
      </div>
    </div>
  </div>
</template>

<script setup>
import AccessCard from '@/components/app/dashboard/settings/AccessCard.vue';
import AiModelsCard from '@/components/app/dashboard/settings/AiModelsCard.vue';
</script>
